import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import styles from 'features/menu/components/user-menu/user-details.module.scss';

interface IProps {
  fullName: string;
  initials: string;
}

const UserDetails = ({ fullName, initials }: IProps) => {
  return (
    <Grid className={styles.userInformationContainer}>
      <div className={styles.avatarContainer}>
        <Typography variant="body1">{initials}</Typography>
      </div>
      <div className={styles.nameContainer}>
        <Typography className="name" variant="h5">
          {fullName}
        </Typography>
      </div>
    </Grid>
  );
};

export default UserDetails;
